import { render, staticRenderFns } from "./MainMenuBar.vue?vue&type=template&id=783e4933&scoped=true"
import script from "./MainMenuBar.vue?vue&type=script&lang=js"
export * from "./MainMenuBar.vue?vue&type=script&lang=js"
import style0 from "./MainMenuBar.vue?vue&type=style&index=0&id=783e4933&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783e4933",
  null
  
)

export default component.exports